import { v4 as uuid } from "uuid";
import {APP_STATE} from "@/actions/globalConst";
import DB from "@/models/DB";
import PaginationModel from "@/models/PPC/Base/PaginationModel";
import { CustomerModel } from "@/models/Customer";
import { CompanyModel } from "@/models/PPC/Company";


const rejectEventHandler=((state, action) => {
    state.error = action?.payload?.data?.data?.errors;
    state.key = uuid().slice(0, 8);
    state.status = APP_STATE.API_ERROR;
});
const pendingEventHandler=((state, action) => {
    state.apiState = APP_STATE.API_PENDING;
})
let fullFilledEventHandler= ( (state, action) => {
    state.status = APP_STATE.API_READY;
    state.error = null;
    state.selected = null;

    if(action.payload.data.customers) {
        state.customers = DB.newCollection(action.payload.data.customers, CompanyModel);
    }
    if(action.payload.data.customer) {
//        state.selected = DB.newModel(action.payload.data.customer, CustomerModel);
        state.selected = DB.newModel(action.payload.data.customer, CompanyModel);

    }
    if(action.payload.data.company) {
        state.selected = DB.newModel(action.payload.data.company, CompanyModel);
    }
    if(action.payload.data.pagination) {
        state.pagination = DB.newModel(action.payload.data.pagination,PaginationModel);
    }

    if(action.payload.data.redirect) {
        state.redirect = action.payload.data.redirect;
    }
});

const initialState = {
  key: "",
  showModal: "",
  isInProgress: false,
  showSheet: false,
  status: APP_STATE.API_INIT,
  customers: false,
  selected: DB.newModel(null, CompanyModel),
  customerModel: DB.newModel(null, CompanyModel),
  error: null,
  currentView: APP_STATE.APP_VIEW_INIT,
  pagination: null,
  redirect:false
};

export {rejectEventHandler, pendingEventHandler, fullFilledEventHandler, initialState};